import { CrudFilters, HttpError, useMany, useTitle } from "@refinedev/core";
import React, { useState } from 'react'

import { EditButton, List, SaveButton, TagField, useDrawerForm, FilterDropdown, useTable, Edit, BooleanField, TextField, useSelect, DeleteButton, CreateButton } from "@refinedev/antd";
import { Button, Checkbox, Drawer, Form, Input, Space, Table } from "antd";
import { IProduct, ITag } from "interfaces";
import { APP_WRITE_TAG_ID } from "utility/constants";
import styled from '@emotion/styled'
import { EditTag } from "./edit";
import { CreateTag } from "./create";

const TableHeader= styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
interface ISearch {
    name: string;
}

export const TagList: React.FC = () => {
    const { tableProps, searchFormProps } = useTable<ITag, HttpError, ISearch>(
        {
            pagination: {
              pageSize: 20
            },
            onSearch: (values) => {
                const filters: CrudFilters = [];

                filters.push({
                  field: "Name",
                  operator: "contains",
                  value: values.name == "" ? undefined : values.name,
                });

                return filters;
            },
            syncWithLocation: false
        }
    );

    const {
        drawerProps: editDrawerProps,
        formProps: editFormProps,
        saveButtonProps: editSaveButtonProps,
        id: tagId,
        show: showEditDrawer,
    } = useDrawerForm<ITag, HttpError>({
        action: "edit",
        redirect: false,
    });


    const {
      drawerProps: createDrawerProps,
      formProps: createFormProps,
      saveButtonProps: createSaveButtonProps,
      show: showCreateDrawer,
  } = useDrawerForm<ITag, HttpError>({
      action: "create",
      resource: APP_WRITE_TAG_ID,
      redirect: false,
  });

    return (
      <> 
        <List title={"Taggar"}>

          {/* Table header filters */}
          <Form {...searchFormProps} layout="inline">
            <TableHeader>
              <Space>
                <Form.Item name="name">
                  <Input placeholder="Sök tagg" />
                </Form.Item>
                <Button type="primary" onClick={searchFormProps.form?.submit}>
                  Filtrera
                </Button>
              </Space>
              <CreateButton
                resource={APP_WRITE_TAG_ID}
                onClick={() => showCreateDrawer()}
              />
            </TableHeader>
          </Form>

          <br></br>

          <Table
            {...tableProps}
            rowKey="id"
          >
            {/* <Table.Column dataIndex="id" title="Id" /> */}
            <Table.Column dataIndex="Name" title="Namn" sorter/>
            <Table.Column
              align="center"
              dataIndex="IsUsed"
              title="Används"
              render={(value) => <BooleanField value={value} />}
            />
            <Table.Column<ITag>
              title="Handling"
              align="center"
              dataIndex="actions"
              render={(_, record) => (
                <Space>
                  <EditButton
                    hideText
                    size="small"
                    recordItemId={record.id}
                    onClick={() => showEditDrawer(record.id)}
                  />
                  <DeleteButton hideText size="small" disabled={record.IsUsed} recordItemId={record.id}/>
                </Space>
              )}
            />
          </Table>
        </List>
        <EditTag
          drawerProps={editDrawerProps}
          formProps={editFormProps}
          saveButtonProps={editSaveButtonProps}
          editId={tagId}
        ></EditTag>
        <CreateTag
          drawerProps={createDrawerProps}
          formProps={createFormProps}
          saveButtonProps={createSaveButtonProps}
        ></CreateTag>
      </>
    );
};